import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/pages/home/App.vue";

Vue.use(Router);

const router = new Router({
    mode: "history",
    
    routes: [
        {
            path: "/",
            name: "index",
            component: Home
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

export default router
